import { useSearchParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { API, Auth } from "aws-amplify";
import {
  getGoogleRoomDetails,
  GetPodSession,
  getUser,
  GetOrganizationDetails,
  ListPodExamCodesByClientId,
} from "../graphql/queries";
import { UpdatePodSession, updateUser, createUser } from "../graphql/mutations";
import { Box, Text, Layer, Button, TextArea } from "grommet";
import { useGoogleLogin } from "@react-oauth/google";
import MonitorEDUQuickButtons from "../Components/MonitorEDUQuickButtons";
import SessionDataTable from "../Components/SessionDataTable";
import ABMDI from "../Components/PodIntegrations/ABMDI";
import Tocico from "../Components/PodIntegrations/Tocico";
import PodTesterInfoCard from "../Components/PodComponents/PodTesterInfoCard";
import PodAlertsCard from "../Components/PodComponents/PodAlertsCard";
import PodImageModal from "../Components/PodComponents/PodImageModal";
import PodHPEIntegration from "../Components/PodIntegrations/HPE";
import { getFieldValue } from "../Components/PodV2/sessionUtils";
export default function PodSession() {
  const [loading, setLoading] = useState(true);
  const [podSession, setPodSession] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [user, setUser] = useState(null);
  const [userEmail, setUserEmail] = useState(null);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [meetLoading, setMeetLoading] = useState(false);
  const [localNotes, setLocalNotes] = useState("");
  const [notesLoading, setNotesLoading] = useState(false);
  const [organization, setOrganization] = useState(null);
  const [localMeetLink, setLocalMeetLink] = useState("");
  const [meetLinkLoading, setMeetLinkLoading] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [referenceId, setReferenceId] = useState("");
  const [lastFour, setLastFour] = useState("");
  const [showIntegrationLayer, setShowIntegrationLayer] = useState(false);
  const [podExamCodes, setPodExamCodes] = useState([]);
  const [loungeStream, setLoungeStream] = useState(null);
  let [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const fetchPodSession = async () => {
      const id = searchParams.get("id");
      const podSession = await API.graphql({
        query: GetPodSession,
        variables: { id: id },
      });
      console.log("pod", podSession);
      fetchOrganization(podSession.data.getPodSession.organizationId);
      setPodSession(podSession.data.getPodSession);
      setLocalNotes(podSession.data.getPodSession.notes || "");
      setLocalMeetLink(podSession.data.getPodSession.googleMeetLink || "");
      setLoading(false);
      setReferenceId(
        (podSession.data.getPodSession.fields ?? []).find(
          (field) => field.key === "receipt",
        )?.value || "",
      );
      setLastFour(
        (podSession.data.getPodSession.fields ?? []).find(
          (field) => field.key === "appointmentid",
        )?.value || "",
      );
    };

    const fetchOrganization = async (id) => {
      const organization = await API.graphql({
        query: GetOrganizationDetails,
        variables: { organizationId: id },
      });
      console.log("organization", organization);
      console.log(JSON.parse(organization.data.getOrganizationDetails).body);
      if (
        JSON.parse(organization.data.getOrganizationDetails).body.streams
          .length > 0
      ) {
        setLoungeStream(
          JSON.parse(organization.data.getOrganizationDetails).body.streams[0],
        );
      }
      setOrganization(
        JSON.parse(organization.data.getOrganizationDetails).body,
      );
    };

    fetchPodSession();
  }, [searchParams]);

  useEffect(() => {
    if (podSession && organization) {
      const originalTitle = document.title;
      document.title = `${podSession.testerName} | ${organization.name}`;

      return () => {
        document.title = originalTitle;
      };
    }
  }, [podSession, organization]);

  useEffect(() => {
    const fetchUser = async () => {
      Auth.currentUserInfo()
        .then(async (user) => {
          console.log(user);
          setUserEmail(user.attributes.email);
          const userData = await API.graphql({
            query: getUser,
            variables: { id: user.id },
          });
          console.log("USA", userData);

          if (userData.data.getUser === null) {
            const newUser = await API.graphql({
              query: createUser,
              variables: {
                input: {
                  id: user.id,
                  email: user.attributes.email,
                },
              },
            });
            console.log("New User", newUser);
            setUser(newUser.data.createUser);
          } else {
            setUser(userData.data.getUser);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };
    fetchUser();
  }, []);

  useEffect(() => {
    const fetchPodExamCodes = async () => {
      try {
        const allItems = [];
        let nextToken = null;
        do {
          const data = await API.graphql({
            query: ListPodExamCodesByClientId,
            variables: {
              client_id: podSession.organizationId,
              limit: 1000,
              nextToken: nextToken || undefined,
            },
          });
          const result = data.data.podExamCodesByClientId;
          allItems.push(...(result.items ?? []));
          nextToken = result.nextToken ?? null;
        } while (nextToken);
        console.log("exam codes", allItems);
        setPodExamCodes(allItems);
      } catch (error) {
        console.error(error);
      }
    };

    if (podSession) {
      fetchPodExamCodes();
    }
  }, [podSession]);

  const handleImageClick = (imageUrl, imageType) => {
    setSelectedImage({ url: imageUrl, type: imageType });
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const handleGenerateGoogleMeetLink = async () => {
    if (!isUserTokens) {
      console.log("User does not have tokens");
      setShowLoginModal(true);
      return;
    } else {
      console.log("User has tokens");
      setMeetLoading(true);
      const data = await API.graphql({
        query: getGoogleRoomDetails,
        variables: {
          action: "createRoom",
          payload: JSON.stringify({
            clientId: podSession.organizationId,
            accessToken: user.googleAccessToken,
            refreshToken: user.googleRefreshToken,
          }),
        },
      });
      console.log(data);
      let parsed = JSON.parse(data.data.getGoogleRoomDetails);
      console.log(parsed);
      if (parsed.statusCode === 200) {
        console.log("success");
        if (parsed.body[0].meetingUri) {
          handleUpdateSessionOnMeetLink(parsed.body[0].meetingUri);
        } else {
          console.log("no meeting uri");
          setMeetLoading(false);
          setShowLoginModal(true);
        }
      }
    }
  };

  const isUserTokens =
    user?.googleAccessToken &&
    user?.googleRefreshToken &&
    user?.googleTokenExpiry;

  const updateUserTokens = async (accessToken, refreshToken, expiry) => {
    const userData = await API.graphql({
      query: updateUser,
      variables: {
        input: {
          id: user.id,
          googleAccessToken: accessToken,
          googleRefreshToken: refreshToken,
          googleTokenExpiry: expiry,
        },
      },
    });

    setUser(userData.data.getUser);
    // refresh the page
    window.location.reload();
    setShowLoginModal(false);
  };

  const getUserTokens = async (code) => {
    const data = await API.graphql({
      query: getGoogleRoomDetails,
      variables: {
        action: "getInitialTokens",
        payload: JSON.stringify({
          code: code,
        }),
      },
    });

    let parsed = JSON.parse(data.data.getGoogleRoomDetails);
    if (parsed.statusCode === 200) {
      updateUserTokens(
        parsed.body.access_token,
        parsed.body.refresh_token,
        parsed.body.expiry_date,
      );
    }
  };

  const handleLoginWithGoogle = useGoogleLogin({
    onSuccess: (codeResponse) => {
      getUserTokens(codeResponse);
    },
    flow: "auth-code",
    redirect_uri: "postmessage",
    scope:
      "https://www.googleapis.com/auth/spreadsheets https://www.googleapis.com/auth/meetings.space.readonly https://www.googleapis.com/auth/meetings.space.created https://www.googleapis.com/auth/drive.readonly https://www.googleapis.com/auth/drive.meet.readonly https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/drive",
  });

  const handleUpdateSessionOnMeetLink = async (meetLink) => {
    console.log(meetLink);
    const data = await API.graphql({
      query: UpdatePodSession,
      variables: {
        input: {
          id: podSession.id,
          googleMeetLink: meetLink,
        },
      },
      authMode: "AMAZON_COGNITO_USER_POOLS",
    });
    console.log("data", data);
    setPodSession((prev) => ({
      ...prev,
      googleMeetLink: meetLink,
    }));
    setLocalMeetLink(meetLink);
    setMeetLoading(false);

    console.log(data);
  };

  const handleSaveNotes = async () => {
    setNotesLoading(true);
    const data = await API.graphql({
      query: UpdatePodSession,
      variables: {
        input: { id: podSession.id, notes: localNotes },
      },
    });
    setPodSession((prev) => ({
      ...prev,
      notes: localNotes,
    }));
    setNotesLoading(false);
  };

  const handleSaveMeetLink = async () => {
    setMeetLinkLoading(true);
    const data = await API.graphql({
      query: UpdatePodSession,
      variables: {
        input: { id: podSession.id, googleMeetLink: localMeetLink },
      },
    });
    setPodSession((prev) => ({
      ...prev,
      googleMeetLink: localMeetLink,
    }));
    setMeetLinkLoading(false);
  };

  const handleVerifyIdentity = async () => {
    const data = await API.graphql({
      query: UpdatePodSession,
      variables: {
        input: { id: podSession.id, verified_by: userEmail },
      },
    });
    setPodSession((prev) => ({
      ...prev,
      verified_by: userEmail,
    }));
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!loading && !podSession) {
    return <div>Pod session not found</div>;
  }

  const tocicoId = getFieldValue(podSession.fields, "id");

  return (
    <Box>
      <Box>
        {showIntegrationLayer && (
          <Layer
            position="right"
            full="vertical"
            modal
            onClickOutside={() => setShowIntegrationLayer(false)}
          >
            {podSession.organizationId === "abmdi" && (
              <ABMDI
                sessionId={
                  (podSession.fields ?? []).find(
                    (field) => field.key === "abmdisessionid",
                  )?.value
                }
                onClose={() => setShowIntegrationLayer(false)}
              />
            )}
            {podSession.organizationId === "hpe" && (
              <PodHPEIntegration
                name={podSession.testerName}
                onClose={() => setShowIntegrationLayer(false)}
              />
            )}
            {podSession.organizationId === "tocico" && (
              <Tocico
                id={tocicoId || undefined}
                onClose={() => setShowIntegrationLayer(false)}
              />
            )}
          </Layer>
        )}
      </Box>
      <Box
        align="start"
        justify="center"
        fill
        direction="row"
        gap="medium"
        pad={{ horizontal: "medium", vertical: "small" }}
        height={{ min: "medium" }}
      >
        {/* Tester Info */}
        <PodTesterInfoCard
          podSession={podSession}
          tocicoId={tocicoId}
          localMeetLink={localMeetLink}
          setLocalMeetLink={setLocalMeetLink}
          handleSaveMeetLink={handleSaveMeetLink}
          meetLinkLoading={meetLinkLoading}
          handleImageClick={handleImageClick}
          setShowIntegrationLayer={setShowIntegrationLayer}
          handleVerifyIdentity={handleVerifyIdentity}
          meetLoading={meetLoading}
          handleGenerateGoogleMeetLink={handleGenerateGoogleMeetLink}
          podExamCodes={podExamCodes}
          loungeStream={loungeStream}
          userEmail={userEmail}
        />
        {/* Alerts */}
        <PodAlertsCard organization={organization} />

        {/* Image Modal */}
        <PodImageModal selectedImage={selectedImage} closeModal={closeModal} />
        {/* Login Modal */}
        {showLoginModal && (
          <Layer position="right" full="vertical" modal>
            <Box width="medium" pad="medium">
              <Text>
                Login With Google, Click below to authorize google meets. Be
                sure to allow all permissions in the popup by clicking the allow
                checkboxes.
              </Text>
              <Button
                label="Login With Google"
                primary
                color="black"
                onClick={() => handleLoginWithGoogle()}
              />
            </Box>
          </Layer>
        )}
      </Box>
      {/* Notes */}
      <Box align="center" pad="medium" height="medium" gap="small">
        <Text>
          Notes: Use this space to take notes about the session if the sheets
          are not working or slow
        </Text>
        <TextArea
          value={localNotes}
          onChange={(e) => setLocalNotes(e.target.value)}
          placeholder="Enter your notes here"
          fill
        />
        <Button
          label="Save Notes"
          primary
          color="black"
          onClick={() => handleSaveNotes()}
        />
        {notesLoading && <Text>Saving...</Text>}
      </Box>

      {/* Table Section */}
      <Box align="center" pad="medium" gap="small">
        Use the button below to show the full row that you can copy and paste
        into the sheet
        <Button
          label={
            showTable ? "Hide Session Data Table" : "Show Session Data Table"
          }
          primary
          color="black"
          onClick={() => setShowTable(!showTable)}
        />
        {showTable && <SessionDataTable podSession={podSession} />}
      </Box>
      <MonitorEDUQuickButtons
        property_link={organization?.property_link}
        email={podSession.testerEmail}
        referenceId={referenceId}
        lastFour={lastFour}
        user={userEmail}
        podSession={podSession}
      />
    </Box>
  );
}
